import { Button, Chip, Stack } from '@mui/material';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import { useT } from '../../i18n';
import { PLAY_STORE_URL } from './config';

// Resident-app download CTA, shared by the hero and the "for residents" section.
// While PLAY_STORE_URL is null the app is not published yet, so we show a disabled
// button with a "Segera hadir" chip instead of a broken link.
export function ResidentDownloadButton({ size = 'large' }: { size?: 'medium' | 'large' }) {
  const t = useT();

  if (PLAY_STORE_URL) {
    return (
      <Button
        size={size}
        variant="outlined"
        color="primary"
        startIcon={<GetAppRoundedIcon />}
        component="a"
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener"
      >
        {t('landing.hero.ctaApp')}
      </Button>
    );
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button size={size} variant="outlined" color="primary" startIcon={<GetAppRoundedIcon />} disabled>
        {t('landing.hero.ctaApp')}
      </Button>
      <Chip size="small" color="warning" variant="outlined" label={t('landing.res.comingSoon')} />
    </Stack>
  );
}
